import { formatDate } from '../utils/formatters'; // Wir erstellen diese Datei gleich

// Basis-Spalten, die in mehreren Tabellen vorkommen
const baseColumns = {
  batchId: { key: 'batch_id', header: 'Chargen-ID', sortable: true },
  batchName: { key: 'batch_name', header: 'Chargenname', sortable: true },
  batchQuantity: { key: 'batch_quantity', header: 'Chargenmenge', sortable: true },
  sellerId: { key: 'sub_vo_id', header: 'Verkäufer-ID', sortable: true },
  sellerName: { 
    key: 't_sub_vo.company_name', 
    header: 'Verkäufer', 
    sortable: true,
    // 'render' ist eine Funktion, die den Zellinhalt individuell formatiert
    render: (batch) => batch.t_sub_vo ? batch.t_sub_vo.company_name : 'N/A' 
  },
  serviceId: { key: 'service_id', header: 'Service-ID', sortable: true },
  serviceName: { 
    key: 't_services.service_name', 
    header: 'Service-Name', 
    sortable: true,
    render: (batch) => batch.t_services ? batch.t_services.service_name : 'N/A'
  },
  tariffId: { key: 'tariff_id', header: 'Tarif-ID', sortable: true },
  tariffName: { 
    key: 't_tariffs.tariff_name', 
    header: 'Tarif-Name', 
    sortable: true,
    render: (batch) => batch.t_tariffs ? batch.t_tariffs.tariff_name : 'N/A'
  },
  validFrom: { 
    key: 'validity_from_date', 
    header: 'Gültig ab', 
    sortable: true,
    render: (batch) => formatDate(batch.validity_from_date)
  },
  validUntil: { 
    key: 'validity_until_date', 
    header: 'Gültig bis', 
    sortable: true,
    render: (batch) => formatDate(batch.validity_until_date)
  },
  // Fügen Sie hier einfach weitere wiederverwendbare Spalten hinzu
};

// Spezifische Konfiguration für den Chargen Miet-Manager
export const rentManagerColumns = [
  baseColumns.batchId,
  baseColumns.batchName,
  baseColumns.batchQuantity,
  { key: 'rented_quantity', header: 'davon Kommissioniert', sortable: true }, // Früher: Vermietete Anzahl
  
  baseColumns.sellerId,
  baseColumns.sellerName,
  baseColumns.serviceId,
  baseColumns.serviceName,
  baseColumns.tariffId,
  baseColumns.tariffName,
  baseColumns.validFrom,
  baseColumns.validUntil,
  // Hier könnten wir auch Erstellungsdatum hinzufügen, wenn die Datenquelle es liefert
  // { key: 'creation_date', header: 'Erstellungsdatum', render: (batch) => formatDate(batch.creation_date) }
];

// Konfiguration für den normalen Batch-Manager (M3)
export const batchManagerColumns = [
  baseColumns.batchId,
  baseColumns.batchName,
  baseColumns.batchQuantity,
  baseColumns.sellerId,
  baseColumns.sellerName,
  baseColumns.serviceId,
  baseColumns.serviceName,
  baseColumns.tariffId,
  baseColumns.tariffName,
  baseColumns.validFrom,
  baseColumns.validUntil,
];

// HINZUGEFÜGT: Konfiguration für die Übersicht der vermieteten Chargen (S5)
export const rentedBatchesColumns = [
  { key: 'order_id', header: 'Bestellnummer', sortable: true },
  { key: 'batch.batch_id', header: 'Chargen ID', sortable: false, render: (order) => order.batch ? order.batch.batch_id : 'N/A' },
  { key: 'batch.batch_name', header: 'Chargenname', sortable: false, render: (order) => order.batch ? order.batch.batch_name : 'N/A' },
  { key: 'batch.service_id', header: 'Service-ID', sortable: false, render: (order) => order.batch ? order.batch.service_id : 'N/A' },
  { key: 'batch.t_services.service_name', header: 'Service-Name', sortable: false, render: (order) => order.batch && order.batch.t_services ? order.batch.t_services.service_name : 'N/A' },
  { key: 'batch.tariff_id', header: 'Tarif-ID', sortable: false, render: (order) => order.batch ? order.batch.tariff_id : 'N/A' },
  { key: 'batch.t_tariffs.tariff_name', header: 'Tarif-Name', sortable: false, render: (order) => order.batch && order.batch.t_tariffs ? order.batch.t_tariffs.tariff_name : 'N/A' },
  { key: 'buyer_id', header: 'Käufer-ID', sortable: true },
  { key: 'buyer', header: 'Käufer', sortable: false, render: (order) => (order.buyerSubVo ? order.buyerSubVo.company_name : (order.buyerAd ? order.buyerAd.company_name : 'N/A')) },
  { key: 'seller_id', header: 'Verkäufer-ID', sortable: true },
  { key: 'seller', header: 'Verkäufer', sortable: false, render: (order) => (order.sellerMainVo ? order.sellerMainVo.company_name : (order.sellerSubVo ? order.sellerSubVo.company_name : 'N/A')) },
  { key: 'order_quantity', header: 'Kommissionierte Menge', sortable: true },
  { key: 'total_price', header: 'Betrag (Brutto)', sortable: true, render: (order) => `${order.total_price} €` }, // Annahme, Preis ist Brutto und in EUR
  { key: 'order_date', header: 'Bestelldatum', sortable: true, render: (order) => formatDate(order.order_date) },
  { key: 'batch.validity_from_date', header: 'Gültig ab', sortable: false, render: (order) => order.batch ? formatDate(order.batch.validity_from_date) : 'N/A' },
  { key: 'batch.validity_until_date', header: 'Gültig bis', sortable: false, render: (order) => order.batch ? formatDate(order.batch.validity_until_date) : 'N/A' },
];